import styles from './paginator.module.scss';
import React from "react";

import { eventHandler } from "@dblimp/core";
import { fields } from "@dblimp/bs5";

const PaginationField = (fields as any).PaginationField;

export interface PaginatorProps {
  name?: string;
  classes?: string;
  /** Página actual (1-based). */
  page: number;
  /** Total de páginas. */
  total: number;
  /** Callback al cambiar de página. */
  onChange: (page: number) => void;
  /** Contenido opcional al centro (p. ej. el carrusel de avisos). */
  children?: React.ReactNode;
}

/**
 * Paginador sticky (por encima del navbar inferior).
 *
 * Usa el `PaginationField` de `@dblimp/bs5` para los controles
 * (`« ‹ [N] / T › »`) y añade el rótulo "pag. N de T" a la izquierda.
 * El campo emite su valor por `eventHandler` con el `name`; aquí se escucha
 * para propagarlo por `onChange`.
 */
export default class Paginator extends React.Component<PaginatorProps> {
  static jsClass = "Paginator";
  static defaultProps: Partial<PaginatorProps> = {
    name: "mbPaginator",
  };

  private uid = "mbPaginator." + Math.random().toString(36).slice(2, 8);

  componentDidMount() {
    eventHandler.subscribe(this.props.name!, this.handleData, this.uid);
  }

  componentWillUnmount() {
    eventHandler.unsubscribe(this.props.name!, this.uid);
  }

  private handleData = (data: any) => {
    const name = this.props.name!;
    const raw = data && data[name] != null ? data[name] : data;
    const page = Number(raw);
    if (page && page !== this.props.page) this.props.onChange?.(page);
  };

  render(): React.ReactNode {
    const { classes, name, page, total, children } = this.props;
    return (
      <nav
        className={styles['mb-paginator'] + (classes ? ' ' + classes : '')}
        aria-label="Paginación">
        <span className={styles['mb-paginator__label']}>
          pag. {page} de {total}
        </span>
        {children}
        <PaginationField
          name={name}
          default={page}
          total={total}
          paginationClasses="pagination-sm"
        />
      </nav>
    );
  }
}
